import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HasPermissionDirective } from './has-permission/has-permission.directive';
import { PhoneFormatterDirective } from './phone-formatter/phone-formatter.directive';
import { NumberFormatterDirective } from './number-formatter/number-formatter.directive';
import { UniconDecimalFormatterDirective } from './decimal-number/decimal-number.directive';
import { DateFormatDirective } from './date-formatted/date-formatted.directive';

@NgModule({
  declarations: [
    HasPermissionDirective,
    PhoneFormatterDirective,
    NumberFormatterDirective,
    UniconDecimalFormatterDirective,
    DateFormatDirective,
  ],
  imports: [CommonModule],
  exports: [
    HasPermissionDirective,
    PhoneFormatterDirective,
    NumberFormatterDirective,
    UniconDecimalFormatterDirective,
    DateFormatDirective,
  ],
})
export class DirectivesModule {}
